import { X } from 'lucide-react';
import { QRCodeSVG } from 'qrcode.react';

type QRCodeModalProps = {
  qrCode: string;
  onClose: () => void;
};

export default function QRCodeModal({ qrCode, onClose }: QRCodeModalProps) {
  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center p-4 z-50">
      <div className="bg-white rounded-2xl shadow-xl p-6 w-full max-w-sm relative">
        <button
          onClick={onClose}
          className="absolute top-4 right-4 text-gray-400 hover:text-gray-600 transition"
        >
          <X className="w-6 h-6" />
        </button>

        <div className="text-center">
          <h2 className="text-2xl font-bold text-gray-900 mb-4 font-heading">Your QR Code</h2>
          <p className="text-gray-600 mb-6">Show this to a Solace representative</p>

          <div className="flex justify-center mb-4">
            <div className="bg-white p-4 rounded-lg border-2 border-gray-200">
              <QRCodeSVG value={qrCode} size={250} />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
